import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportIncomeComponent } from './report-income.component';
import { SharedModule } from '../../shared/shared.module';
import { ReportIncomeService } from './report-income.service';
import { RouterModule } from '@angular/router';
import { ReportIncomeListComponent } from './report-income-list/report-income-list.component';
import { ReportIncomeConfirmationComponent } from './report-income-confirmation/report-income-confirmation.component';
import { ReportIncomeResultComponent } from './report-income-result/report-income-result.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		RouterModule
	],
	declarations: [
		ReportIncomeComponent,
		ReportIncomeListComponent,
		ReportIncomeConfirmationComponent,
		ReportIncomeResultComponent
	],
	exports: [
		ReportIncomeComponent
	],
	providers: [ReportIncomeService]
})
export class ReportIncomeModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/report-income/report-income.module.ts